import https from "./https";

export const initialize = async payload => {
    try {
        return await https.post("/widget/initialize", payload);
    } catch (err) {
        throw err;
    }
}



// payload = { type: "transactionInitiated", frameId: _this.state.frameId, host:_this.state.host, transactionData: initializeData.data }
export const registerActivity = async payload => {
    try {
        return await https.post("/widget/activity", payload)
    }catch(err){
        console.log(err)
    }
}


export const getLocation = async () => {
    try {
        return await https.get("https://ipapi.co/json")
    } catch ( err ) {
        throw err;
    }
}

export const convert = async (from, to) => {
    try {
        return await https.get(`https://min-api.cryptocompare.com/data/price?fsym=${from}&tsyms=${to}`)
    } catch ( err ) {
        throw err;
    }
}